import axiosInstance from '../../../config/axiosInstance';
const JobAssetService = {
    async GetAllJobAssets(redirectCallback,IssueID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetAllIssueAsset?IssueID=${IssueID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },    
    async DeleteJobAsset(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/DeleteIssueAsset?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AssetIssue(redirectCallback,IssueID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/AssetIssue?IssueID=${IssueID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }, 
    async GetIssueByAssetID(AssetID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetIssueByAssetID?AssetID=${AssetID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }, 
};

export default JobAssetService;